(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["stacked-image-tabs-block"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('stacked-image-tabs-block')) {
    customElements.define('stacked-image-tabs-block', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.cards = Array.from(this.querySelectorAll('.sitb__card'));
        this.tabs = Array.from(this.querySelectorAll('.sitb__tab'));
        this.stage = this.querySelector('.sitb__stage');
        this.current = 0;
        this.gesture = null;
        if (!this.cards.length) return;
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index), options);
          tab.addEventListener('keydown', event => {
            let target;
            if (event.key === 'ArrowRight') target = (index + 1) % this.cards.length;
            if (event.key === 'ArrowLeft') target = (index - 1 + this.cards.length) % this.cards.length;
            if (event.key === 'Home') target = 0;
            if (event.key === 'End') target = this.cards.length - 1;
            if (target === undefined) return;
            event.preventDefault();
            this.select(target);
            this.tabs[target].focus({ preventScroll: true });
          }, options);
        });
        this.stage.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0 || this.cards.length < 2) return;
          this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, dx: 0, horizontal: false, start: performance.now() };
          this.stage.setPointerCapture(event.pointerId);
        }, options);
        this.stage.addEventListener('pointermove', event => {
          const g = this.gesture;
          if (!g || event.pointerId !== g.id) return;
          const dx = event.clientX - g.x;
          const dy = event.clientY - g.y;
          if (!g.horizontal && Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 8) { this.finish(false); return; }
          if (!g.horizontal && Math.abs(dx) > 7) { g.horizontal = true; this.classList.add('is-dragging'); }
          if (!g.horizontal) return;
          g.dx = dx;
          this.style.setProperty('--sitb-drag', `${Math.max(-100, Math.min(100, dx * .45))}px`);
        }, options);
        this.stage.addEventListener('pointerup', () => this.finish(true), options);
        this.stage.addEventListener('pointercancel', () => this.finish(false), options);
        this.stage.addEventListener('lostpointercapture', () => this.finish(false), options);
        this.select(0, false);
      }
      disconnectedCallback() { this.controller?.abort(); }
      finish(commit) {
        const g = this.gesture;
        if (!g) return;
        this.gesture = null;
        this.classList.remove('is-dragging');
        this.style.removeProperty('--sitb-drag');
        if (this.stage.hasPointerCapture(g.id)) this.stage.releasePointerCapture(g.id);
        const threshold = Math.min(70, this.stage.clientWidth * .12);
        const flick = Math.abs(g.dx) > 20 && Math.abs(g.dx) / Math.max(1, performance.now() - g.start) > .35;
        if (commit && g.horizontal && (Math.abs(g.dx) > threshold || flick)) this.select(this.current + (g.dx < 0 ? 1 : -1));
      }
      select(index, scroll = true) {
        const count = this.cards.length;
        const next = (index + count) % count;
        if (this.cards[this.current]?.contains(document.activeElement) && next !== this.current) this.tabs[next].focus({ preventScroll: true });
        this.current = next;
        this.cards.forEach((card, i) => {
          const slot = (i - next + count) % count;
          const active = slot === 0;
          card.style.setProperty('--sitb-x', `${Math.min(slot, 3) * 17}%`);
          card.style.setProperty('--sitb-mobile-x', `${Math.min(slot, 3) * 16}%`);
          card.style.setProperty('--sitb-scale', String(1 - Math.min(slot, 3) * .1));
          card.style.zIndex = String(count - slot);
          card.style.opacity = slot > 3 ? '0' : '1';
          card.classList.toggle('is-active', active);
          card.setAttribute('aria-hidden', String(!active));
          card.tabIndex = active ? 0 : -1;
          this.tabs[i].setAttribute('aria-selected', String(active));
          this.tabs[i].tabIndex = active ? 0 : -1;
        });
        if (scroll) {
          const list = this.tabs[next].parentElement;
          list.scrollTo({ left: this.tabs[next].offsetLeft - (list.clientWidth - this.tabs[next].offsetWidth) / 2, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
